import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(isBetween);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

export const ISO_DATE_FORMAT_STRING: string = 'YYYY-MM-DD';
export const FULL_LENGTH_MONTH_FORMAT: string = 'MMMM';
export const FULL_LENGTH_MONTH_YEAR_FORMAT: string = 'MMMM YYYY';

export { dayjs };
